<template>
  <div class="row living-options">
    <card-tabs 
      class="col-12 w-100" 
      :tabs="[
        { 
          label: 'Sessions',
          id: 'sessions',
        }, 
        { 
          label: 'Pages',
          id: 'pages',
        }
      ]"
      :active-tab="activeTab"
      @tabClick="navigateToTab"
    >
      <template v-slot:sessions>
        <HeatmapsSessions></HeatmapsSessions>
      </template>
      <template v-slot:pages>
        <HeatmapsPages></HeatmapsPages>
      </template>
    </card-tabs>   
  </div>
</template>
<script>
import { camelCase } from 'lodash'
import CardTabs from '@/components/Cards/TabsCard'
import HeatmapsSessions from './HeatmapsSessions'
import HeatmapsPages from './HeatmapsPages'

export default {
  components: { CardTabs, HeatmapsSessions, HeatmapsPages },

  computed: {
    activeTab () {
      return camelCase(this.$route.name)
    }
  },

  beforeRouteEnter(to, from, next) {
    if (to.path === '/heatmaps') {
      next('/heatmaps/sessions')
    } else {
      next()
    }
  },

  beforeRouteUpdate (to, from, next) {
    if (to.path === '/heatmaps') {
      next('/heatmaps/sessions')
    } else {
      next()
    }
  },

  methods: {
    navigateToTab (tab) {
      this.$router.push('/heatmaps/' + tab)
    }
  }
}
</script>